var VAHRO_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycby5spOfjQZHPi_OYZOTbJMOgxRv_xkKOk8VzMLJfEWoA61V0LPwc4jhCI39dbKQ9__I/exec';

function vahroSubmit() {
  var form = document.getElementById('vf-form');
  var btn = document.getElementById('vf-submit-btn');
  var successState = document.getElementById('vf-success');
  var errorMsg = document.getElementById('vf-error');

  if (!form) return;

  errorMsg.classList.remove('visible');

  var required = ['q1_overall', 'q2_store_look', 'q3_staff', 'q4_collection'];
  for (var i = 0; i < required.length; i++) {
    var checked = form.querySelector('input[name="' + required[i] + '"]:checked');
    if (!checked) {
      var firstInput = form.querySelector('input[name="' + required[i] + '"]');
      if (firstInput) firstInput.closest('.vf-question').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
  }

  btn.disabled = true;
  btn.textContent = 'Submitting…';

  var payload = {
    timestamp: new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
    q1_overall: form.querySelector('input[name="q1_overall"]:checked').value,
    q2_store_look: form.querySelector('input[name="q2_store_look"]:checked').value,
    q3_staff: form.querySelector('input[name="q3_staff"]:checked').value,
    q4_collection: form.querySelector('input[name="q4_collection"]:checked').value,
    q5_missing: form.querySelector('[name="q5_missing"]').value.trim(),
    q6_improve: form.querySelector('[name="q6_improve"]').value.trim()
  };

  fetch(VAHRO_SCRIPT_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }).then(function() {
    form.style.display = 'none';
    successState.classList.add('visible');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }).catch(function() {
    btn.disabled = false;
    btn.textContent = 'Submit Feedback';
    errorMsg.classList.add('visible');
  });
}
